import { render, staticRenderFns } from "./AggregateLearningLeaderboardFullView.vue?vue&type=template&id=59d92594&scoped=true"
import script from "./AggregateLearningLeaderboardFullView.vue?vue&type=script&lang=js"
export * from "./AggregateLearningLeaderboardFullView.vue?vue&type=script&lang=js"
import style0 from "./AggregateLearningLeaderboardFullView.vue?vue&type=style&index=0&id=59d92594&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59d92594",
  null
  
)

export default component.exports